export default {
  NotPosted: 0,
  Posted: 1
};
